@if (order) {
  <ng-container
    *ngTemplateOutlet="mobileDevice ? mobileView : desktopView"
  ></ng-container>
}

<ng-template #desktopView>
  <div id="order-info" class="order-info--container me-3">
    <div class="order-info--container--header pb-3 line-separator--grey">
      @if (order.started_at) {
        <h3 id="order-date" class="m-0">
          Order Date: {{ order.started_at.date | dateFormat }}
        </h3>
      }
      <h1 id="order-number" class="m-0">Order #{{ order.id }}</h1>
      <div>
        <button
          id="export-to-excel-btn"
          class="btn btn-icon large with-border with-shadow background-white me-2"
          title="Export to Excel"
          (click)="onExportToExcel()"
        >
          <i class="fal fa-file-excel"></i>
        </button>
        <button
          id="export-to-pdf-btn"
          class="btn btn-icon large with-border with-shadow background-white"
          title="Export to PDF"
          (click)="onExportToPDF()"
        >
          <i class="fal fa-file-pdf"></i>
        </button>
      </div>
    </div>
    <div class="order-info--container--details mt-3">
      <div>
        <div>
          <span class="fw-bold">Name: </span
          ><span id="order-name">{{ order.attr_cart_name }}</span>
        </div>
        <div>
          <span class="fw-bold">Attention: </span
          ><span
            id="order-attention"
            [ngClass]="{ 'color-gray': order.isAttentionOverridden }"
            >{{ order.attention }}</span
          >
        </div>
        <div>
          <span class="fw-bold">PO: </span
          ><span id="order-po">{{ order.attr_po_num }}</span>
        </div>
        <div>
          <span class="fw-bold">Order Notes: </span
          ><span id="order-notes">{{ order.attr_notes }}</span>
        </div>
      </div>
      <div>
        <div>
          <span class="fw-bold">Status: </span
          ><span id="order-status">{{ status }}</span>
        </div>
        <div>
          <span class="fw-bold">Payment Method: </span
          ><span id="order-payment-method">{{ paymentMethod }}</span>
        </div>
        @if (order.costCenter) {
          <div>
            <span class="fw-bold">SAP: </span
            ><span id="order-sap">{{ order.costCenter.getLongAccount() }}</span>
          </div>
        }
        @if (order.creditCard) {
          <div>
            <span class="fw-bold">Card Name: </span
            ><span id="order-card-name">{{ order.creditCard.label }}</span>
          </div>
        }
        <div>
          <span class="fw-bold">Invoices: </span
          ><span>
            @if ($isInvoiceExistsForOrder | async) {
              <a
                id="order-invoices-link"
                class="link no-uppercase link-underline"
                (click)="onDownloadInvoiceExcel($event)"
                >View POCM Invoices</a
              >
            }
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mobileView>
  <div id="order-info-mobile" class="order-info--container mobile">
    <div class="order-info--container--header pb-3 line-separator--grey">
      <h1 id="order-number-mobile" class="m-0">Order #{{ order.id }}</h1>
      @if (order.started_at) {
        <h5 id="order-date-mobile" class="m-0">
          Order Date: {{ order.started_at.date | dateFormat }}
        </h5>
      }
      <div class="mt-3">
        <button
          id="export-to-excel-btn-mobile"
          class="btn btn-icon large with-border with-shadow background-white me-2"
          title="Export to Excel"
          (click)="onExportToExcel()"
        >
          <i class="fal fa-file-excel"></i>
        </button>
        <button
          id="export-to-pdf-btn-mobile"
          class="btn btn-icon large with-border with-shadow background-white"
          title="Export to PDF"
          (click)="onExportToPDF()"
        >
          <i class="fal fa-file-pdf"></i>
        </button>
      </div>
    </div>
    <div class="order-info--container--details mt-3">
      <div>
        <div>
          <span class="fw-bold">Name: </span
          ><span id="order-name-mobile">{{ order.attr_cart_name }}</span>
        </div>
        <div>
          <span class="fw-bold">Status: </span
          ><span id="order-status-mobile">{{ status }}</span>
        </div>
        <div>
          <span class="fw-bold">Payment Method: </span
          ><span id="order-payment-method-mobile">{{ paymentMethod }}</span>
        </div>
        @if (order.costCenter) {
          <div>
            <span class="fw-bold">SAP: </span
            ><span id="order-sap-mobile">{{
              order.costCenter.getLongAccount()
            }}</span>
          </div>
        }
        @if (order.creditCard) {
          <div>
            <span class="fw-bold">Card Name: </span
            ><span id="order-card-name-mobile">{{
              order.creditCard.label
            }}</span>
          </div>
        }
        <div>
          <span class="fw-bold">Attention: </span
          ><span
            id="order-attention-mobile"
            [ngClass]="{ 'color-gray': order.isAttentionOverridden }"
            >{{ order.attention }}</span
          >
        </div>
        <div>
          <span class="fw-bold">PO: </span
          ><span id="order-po-mobile">{{ order.attr_po_num }}</span>
        </div>
        <div>
          <span class="fw-bold">Order Notes: </span
          ><span id="order-notes-mobile">{{ order.attr_notes }}</span>
        </div>
        <div>
          <span class="fw-bold">Invoices: </span
          ><span>
            @if ($isInvoiceExistsForOrder | async) {
              <a
                id="order-invoices-link-mobile"
                class="link no-uppercase link-underline"
                (click)="onDownloadInvoiceExcel($event)"
                >View POCM Invoices</a
              >
            }
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
